import { Component, EventEmitter, Inject, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InterfaceAppServiceRegister, TreeNodeRegister } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { TreeService } from '@directives/tree/services/tree.service';
import { TreeDirective } from '@directives/tree/tree.directive';
import { NotifierService } from '@services/notifier.service';
@Component({
    selector: 'app-tree-select-dialog',
    templateUrl: './tree-select-dialog.component.html',
    styleUrls: ['./tree-select-dialog.component.css'],
    providers: [TreeService],
})
export class TreeSelectDialogComponent {
    /** Ссылка на директиву создания дерева доступов */
    @ViewChild('treeComponentSelectDialog', { static: false }) treeComponentSelectDialog: TreeDirective;

    /** Состояние кнопки сохрани */
    public invalid: boolean = false;
    /**
     * Конструктор
     * @param {FormBuilder} fb создатель форм
     * @param {AppService} appService сервис взаимодействия с внешними ресурсами
     * @param {MatDialogRef<TreeSelectDialogComponent>} dialogRef ссылка на диалог
     * @param {TreeService} service сервис дерева
     * @param {NotifierService} notifier сервис уведомлений
     * @param {object} data данные для диалога
     */
    constructor(
        private fb: FormBuilder,
        public appService: AppService,
        public dialogRef: MatDialogRef<TreeSelectDialogComponent>,
        public service: TreeService,
        public notifier: NotifierService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            data: {
                isMultiple: boolean;
                isChildrenTree?: boolean;
                isFolderSelect: boolean;
                parentId: number;
                levelOpen: number;
                treeData: InterfaceAppServiceRegister[];
                treeDataGenerate: TreeNodeRegister[];
                isShow: any;
                value: any;
                listId: any;
                isHideEmptyFolder: boolean;
                treeIconsObject: { [key: string]: boolean };
                eventAdd?: EventEmitter<any>;
                is_folder: number;
                buttonAdd?: boolean;
                useDefaultIcons?: boolean;
            };
        },
    ) {}

    /**
     * Сохранение данных
     */
    save() {
        let savedData: {};
        if (this.data.data.isMultiple) {
            const selectedList = this.treeComponentSelectDialog.getSelectedList();

            // ищем, выбраны ли условно удаленные
            for (const item in selectedList) {
                if (this.service.convertTypeRubricatorFlagDel(item)) {
                    this.notifier.notify(
                        'error',
                        this.appService.language_dictionary.unable_select_conditionally_del_rubricator,
                    );
                    return;
                }
            }

            savedData = {
                selected: selectedList,
            };
        } else {
            const selectedItem = this.treeComponentSelectDialog.getSelectedItem();

            if (this.service.convertTypeRubricatorFlagDel(selectedItem)) {
                this.notifier.notify(
                    'error',
                    this.appService.language_dictionary.unable_select_conditionally_del_rubricator,
                );
                return;
            }

            savedData = {
                id: selectedItem.hasOwnProperty('id') ? selectedItem.id : null,
                name: selectedItem.hasOwnProperty('name') ? selectedItem.name : null,
                parent_id: selectedItem.hasOwnProperty('parent_id') ? selectedItem.parent_id : null,
            };
        }

        this.dialogRef.close({
            save: true,
            data: savedData,
        });
    }

    /**
     * Закрытие диалога
     */
    close() {
        this.dialogRef.close({ save: false });
    }

    /** Событие валидации дерева */
    public validateTreeResult($event: { isError: boolean }) {
        this.invalid = $event.isError;
    }
}
